import React from "react"
import PartnerAway from "../../components/PartnerAway/PartnerAway"
import { checkCheckoutPartnerAway } from "../../utils/helpers"
import { FirebaseContext } from "../../firebase"

const CheckoutPartnerAway = (props) => {
  const { dateState, partnerState } = React.useContext(FirebaseContext)
  const showPartnerAway = checkCheckoutPartnerAway(partnerState, dateState)

  return (
    <React.Fragment>
      {showPartnerAway ? (
        <div className="nudge-banner">
          <PartnerAway {...props} />
        </div>
      ) : null}
    </React.Fragment>
  )
}
export default CheckoutPartnerAway
